import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import Components from "ets-components";
import "ets-components/dist/ets-components.css";

// importing the intercerptor
import interceptor from "./logic/interceptors.js";

let config = {
  urlIntranet: process.env.VUE_APP_WEB_INTRANET,
  urlAccount: process.env.VUE_APP_WEB_ACCOUNT,
  urlDevelopers: process.env.VUE_APP_WEB_DEVELOPERS,
  urlEAF: process.env.VUE_APP_WEB_EAF
};

Vue.use(Components, config);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

interceptor();
